module.exports = __webpack_public_path__ + "static/media/background-pagamentos4-mobile.cd25f53a.jpg";